import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import { loadScript } from '../../scripts/helpers';
import { trustpilotScriptUrl, trustpilotScriptId, trustPilotWidgetUrl } from '../../scripts/data';
var TrustpilotWidget = /*#__PURE__*/function (_React$Component) {
  function TrustpilotWidget() {
    var _this;
    _classCallCheck(this, TrustpilotWidget);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TrustpilotWidget, [].concat(args));
    _defineProperty(_this, "trustBoxRef", React.createRef());
    return _this;
  }
  _inherits(TrustpilotWidget, _React$Component);
  return _createClass(TrustpilotWidget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this,
        _this$trustBoxRef;
      if (!window.Trustpilot) {
        loadScript(trustpilotScriptUrl, trustpilotScriptId).then(function () {
          var _this2$trustBoxRef;
          if ((_this2$trustBoxRef = _this2.trustBoxRef) !== null && _this2$trustBoxRef !== void 0 && _this2$trustBoxRef.current && window.Trustpilot) {
            window.Trustpilot.loadFromElement(_this2.trustBoxRef.current, true);
          }
        })["catch"](function (error) {
          console.error(error);
        });
      } else if (window.Trustpilot && (_this$trustBoxRef = this.trustBoxRef) !== null && _this$trustBoxRef !== void 0 && _this$trustBoxRef.current) {
        window.Trustpilot.loadFromElement(this.trustBoxRef.current, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "position-relative my-5 my-lg-0 me-lg-4 d-table mx-auto"
      }, React.createElement("a", {
        className: "trustpilot-outer",
        href: trustPilotWidgetUrl,
        target: "_blank",
        "data-link-both": "public-footer-trustpilot-widget",
        rel: "noopener noreferrer",
        title: "Trust Pilot Reviews",
        "aria-label": "Trust Pilot Reviews"
      }), React.createElement("div", {
        className: "trustpilot-widget",
        ref: this.trustBoxRef,
        "data-locale": "en-US",
        "data-template-id": "5419b757fa0340045cd0c938",
        "data-businessunit-id": "5513972d0000ff00057e4c5b",
        "data-style-height": "25px",
        "data-style-width": "180px"
      }, React.createElement("a", {
        href: trustPilotWidgetUrl,
        target: "_blank",
        "data-link-both": "public-footer-trustpilot-widget",
        rel: "noopener noreferrer"
      }, "Trustpilot")));
    }
  }]);
}(React.Component);
export default TrustpilotWidget;